import { APP_CLEAR_CURRENT_USER } from '../actions/app.actions'
import * as Actions from '../actions/status.actions'

const initialState = {
  edit: {},
  list: [],
  filter_text: '',
  show_modal: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.STATUS_SHOW_MODAL:
      return {
        ...state,
        show_modal: action.show,
      }
    case Actions.STATUS_SET_EDIT:
      return {
        ...state,
        edit: action.edit,
      }
    case Actions.STATUS_CLEAR_EDIT:
      return {
        ...state,
        edit: {},
      }
    case Actions.STATUS_CLEAR:
      return {
        ...state,
        list: [],
      }
    case Actions.STATUS_ADD_ONE:
      return {
        ...state,
        list: [
          ...state.list.filter(
            (status) => status.id !== action.status.id
          ),
          action.status,
        ],
      }
    case Actions.STATUS_REMOVE:
      return {
        ...state,
        list: [
          ...state.list.filter((status) => status.id !== action.status),
        ],
      }
    case Actions.STATUS_SET_FILTER_TEXT:
      return {
        ...state,
        filter_text: action.text,
      }
    case APP_CLEAR_CURRENT_USER:
      return initialState
    default:
      return state
  }
}
